var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42188 16.5469C9.42188 17.5156 10.6094 18 11.9844 18C13.3594 18 14.5312 17.5156 15.5 16.5469C16.5 15.5469 17 14.3594 17 12.9844C17 11.6094 16.5 10.4375 15.5 9.46875C14.5312 8.46875 13.3594 7.96875 11.9844 7.96875C10.6094 7.96875 9.42188 8.46875 8.42188 9.46875C7.45312 10.4375 6.96875 11.6094 6.96875 12.9844C6.96875 14.3594 7.45312 15.5469 8.42188 16.5469ZM8.98438 3H14.9844L16.8125 4.96875H20C20.5312 4.96875 20.9844 5.17188 21.3594 5.57812C21.7656 5.98438 21.9688 6.45312 21.9688 6.98438V18.9844C21.9688 19.5156 21.7656 19.9844 21.3594 20.3906C20.9844 20.7969 20.5312 21 20 21H3.96875C3.4375 21 2.96875 20.7969 2.5625 20.3906C2.1875 19.9844 2 19.5156 2 18.9844V6.98438C2 6.45312 2.1875 5.98438 2.5625 5.57812C2.96875 5.17188 3.4375 4.96875 3.96875 4.96875H7.15625L8.98438 3ZM9.73438 15.2344C9.10938 14.6094 8.79688 13.8594 8.79688 12.9844C8.79688 12.1094 9.10938 11.3594 9.73438 10.7344C10.3594 10.1094 11.1094 9.79688 11.9844 9.79688C12.8594 9.79688 13.6094 10.1094 14.2344 10.7344C14.8594 11.3594 15.1719 12.1094 15.1719 12.9844C15.1719 13.8594 14.8594 14.6094 14.2344 15.2344C13.6094 15.8594 12.8594 16.1719 11.9844 16.1719C11.1094 16.1719 10.3594 15.8594 9.73438 15.2344Z",
    fill: "#027BFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e195b7eff34b16523648e4a8686ce897.svg";
export { ForwardRef as ReactComponent };